import { useState } from 'react';
import UISideNavItem from 'UIComponents/nav/UISideNavItem';
import styled from 'styled-components';
import UILoadingSpinner from 'UIComponents/loading/UILoadingSpinner';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { CardMenu, CardMenuHeader, CardMenuOptions } from '../../cardMenu';
import { ChangePlaylistThumbnail, UploadPlaylistThumbnailButton, useFullPlaylist } from '..';
import PanelSection from '../../../components/Modals/FullScreenModal/PanelSection';
import UIFlex from 'UIComponents/layout/UIFlex';
import UIBox from 'UIComponents/layout/UIBox';
import { MenuRow } from '../../cardMenu/components/MobileCardMenu';
import UsageTracker from '../../../utils/UsageTracker';
import HR from 'UIComponents/elements/HR';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const RowSpinner = styled(UILoadingSpinner).withConfig({
  displayName: "CardMenuChangePlaylistThumbnailOption__RowSpinner",
  componentId: "sc-1s16ehh-0"
})(["position:absolute;right:10px;"]);
const UploadButton = styled(UploadPlaylistThumbnailButton).attrs({
  use: 'link',
  block: true
}).withConfig({
  displayName: "CardMenuChangePlaylistThumbnailOption__UploadButton",
  componentId: "sc-1s16ehh-1"
})(["text-decoration:none !important;font-weight:normal !important;"]);
export const MobileMenuChangePlaylistThumbnailOption = ({
  playlistId,
  onItemClick
}) => {
  return /*#__PURE__*/_jsx(ChangePlaylistThumbnail, {
    onItemClick: onItemClick,
    playlistId: playlistId,
    renderList: content => /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(PanelSection, {
        showBorders: false,
        title: /*#__PURE__*/_jsx(UIFlex, {
          children: /*#__PURE__*/_jsx(UIBox, {
            grow: 1,
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "learningCenter.cardMenu.playlistItems"
            })
          })
        })
      }), content]
    }),
    renderRow: (content, key) => /*#__PURE__*/_jsx(MenuRow, {
      children: content
    }, key)
  });
};
const useIsLoadingPlaylistItems = (playlistId, isOpen) => {
  const {
    playlistLoading
  } = useFullPlaylist(playlistId, !isOpen);
  return playlistLoading;
};
export const CardMenuChangePlaylistThumbnailOption = ({
  playlistId,
  onItemClick,
  onOpenChange,
  render = (handleOpen, isLoading) => /*#__PURE__*/_jsx(UISideNavItem, {
    iconRight: isLoading ? /*#__PURE__*/_jsx(RowSpinner, {
      size: "extra-small"
    }) : 'right',
    onMouseEnter: handleOpen,
    title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "learningCenter.cardMenu.changeThumbnail"
    })
  })
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const handleOnOpenChange = newOpenState => {
    setIsOpen(newOpenState);
    if (onOpenChange) onOpenChange(newOpenState);
  };
  const handleOnItemClick = item => {
    if (onItemClick) onItemClick(item);
    handleOnOpenChange(false);
    UsageTracker.track('playlistInteraction', {
      action: 'choose-thumbnail'
    });
  };
  const handleOnImageUpload = () => {
    handleOnOpenChange(false);
    UsageTracker.track('playlistInteraction', {
      action: 'upload-thumbnail'
    });
  };
  const handleOpen = () => handleOnOpenChange(true);
  const isLoading = useIsLoadingPlaylistItems(playlistId, isOpen);
  return /*#__PURE__*/_jsx(CardMenu, {
    content: {
      header: /*#__PURE__*/_jsx(CardMenuHeader, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "learningCenter.cardMenu.playlistItems"
        })
      }),
      body: /*#__PURE__*/_jsx(_Fragment, {
        children: /*#__PURE__*/_jsx(ChangePlaylistThumbnail, {
          onItemClick: handleOnItemClick,
          playlistId: playlistId
        })
      }),
      footer: /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(HR, {
          distance: "flush"
        }), /*#__PURE__*/_jsx(CardMenuOptions, {
          style: {
            paddingTop: 0,
            paddingBottom: 0
          },
          children: /*#__PURE__*/_jsx(UISideNavItem, {
            linkComponent: "div",
            role: "navigation-item",
            title: /*#__PURE__*/_jsx(UploadButton, {
              onImageUpload: handleOnImageUpload,
              playlistId: playlistId
            })
          })
        })]
      })
    },
    onOpenChange: e => handleOnOpenChange(e.target.value),
    open: isOpen && !isLoading,
    placement: "right bottom",
    children: render(handleOpen, isLoading)
  });
};